import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { AssetCatDropDownDto } from './assets-catagory-drop-down-dto';




export class AssetsCatDropDownResponseModel extends GlobalResponseObject {
    data?: AssetCatDropDownDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: AssetCatDropDownDto[]) {
        super(status, intlCode, internalMessage)
        this.data = data;
    }
}

